<template>
    <div>


        <div v-if="resetLinkSuccessMsg" class="text-green">{{ resetLinkSuccessMsg }}</div>
        <div :class="'user_offcanvas_header text-left ' + (readOnly ? 'readonly_users_heading_1' : 'users_heading_1')">
            {{ card_title }} <span v-if="count > 0"> - {{ count }}</span> &nbsp; 
            <a href="javascript:void(0)" class="see-more branding_text_color" v-if="itemLength > 3 && count > 0" @click="clickShowMore">{{see_more_text}}</a>
        </div>
        <div v-if="!readOnly" class="user_offcanvas_header users_heading_2 text-center">Password </div>
        <div v-if="(!readOnly && isCanAddTransfer == true)" class="user_offcanvas_header users_heading_3 text-center">Add/Transfer </div>
        <div v-if="!readOnly" class="user_offcanvas_header users_heading_4 text-center">Status </div>
        <div class="clearfix"></div>

          <div class="text-center pt-4" v-if="loading == true">
            <div class="row ml-1" v-for="option in 5">
              <div class="users_heading_1" style=" padding-left: 0px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="users_heading_2" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="users_heading_3" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="users_heading_4" style=" padding-left: 10px;"><PuSkeleton :count="1"></PuSkeleton></div>
              <div class="col-12 p-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>

        <div v-if="show_more === false && count > 0">
            <div class="col-12 users_lists" v-for="(user, uindex) in lessResult" :key="uindex">
                <div @click="goToUserDetail(user.id)" :class="'user_offcanvas_content text-left ' + (readOnly ? 'readonly_users_heading_1' : 'users_heading_1')">
                    <div class="uname">{{ capitalizeFirstLetter(user.first_name) + ' ' +  capitalizeFirstLetter(user.last_name) }}</div>
                    <div class="uemail">{{ user.email }}</div>
                </div>
                <div v-if="!readOnly" class="user_offcanvas_content users_heading_2 text-center">
                    <a class="offcanvas_link branding_text_color" @click="openResetLinkModal(user)"> Reset</a>
                </div>
                <div v-if="(!readOnly && isCanAddTransfer == true && user.status == 'Active')" class="user_offcanvas_content users_heading_3 text-center">
                    <a class="offcanvas_link" @click="openTransferLinkModal(user)"> 
                        <img src="@/assets/enterprise/Move_User_16x16.png">
                    </a>
                </div>
                <div v-else-if="(!readOnly && isCanAddTransfer == true)" class="user_offcanvas_content users_heading_3 text-center">
                    &nbsp;
                </div>
                <div v-if="(!readOnly && (card_title == 'Mentees' || card_title == 'Apprentices'))" class="user_offcanvas_content users_heading_4 text-center">
                    <a v-if="user.status == 'Active'" :id="'user-' + user.id" :class="'status_link ' + getFontColor(user.status)" @click="openStatusModal(user)"> {{ formatStatus(user.status) }}</a>
                </div>
                <div v-else-if="(!readOnly)" class="user_offcanvas_content users_heading_4 text-center">
                    <a :id="'user-' + user.id" :class="'status_link ' + getFontColor(user.status)" @click="openStatusModal(user)"> {{ formatStatus(user.status) }}</a>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div v-if="show_more === true && count > 0">
            <div class="col-12 users_lists" v-for="(user, uindex) in allItems" :key="uindex">
                <div @click="goToUserDetail(user.id)" :class="'user_offcanvas_content text-left ' + (readOnly ? 'readonly_users_heading_1' : 'users_heading_1')">
                    <div class="uname">{{ capitalizeFirstLetter(user.first_name) + ' ' +  capitalizeFirstLetter(user.last_name) }}</div>
                    <div class="uemail">{{ user.email }}</div>
                </div>
                <div v-if="!readOnly" class="user_offcanvas_content users_heading_2 text-center">
                    <a class="offcanvas_link branding_text_color" @click="openResetLinkModal(user)"> Reset</a>
                </div>
                <div v-if="(!readOnly && isCanAddTransfer == true && user.status == 'Active')" class="user_offcanvas_content users_heading_3 text-center">
                    <a class="offcanvas_link" @click="openTransferLinkModal(user)"> 
                        <img src="@/assets/enterprise/Move_User_16x16.png">
                    </a>
                </div>
                <div v-else-if="(!readOnly && isCanAddTransfer == true)" class="user_offcanvas_content users_heading_3 text-center">
                    &nbsp;
                </div>
                <div v-if="(!readOnly && (card_title == 'Mentees' || card_title == 'Apprentices'))" class="user_offcanvas_content users_heading_4 text-center">
                    <a :id="'user-' + user.id" v-if="user.status == 'Active'" :class="'status_link ' + getFontColor(user.status)" @click="openStatusModal(user)"> {{ formatStatus(user.status) }}</a>
                </div>
                <div v-else-if="(!readOnly)" class="user_offcanvas_content users_heading_4 text-center">
                    <a :id="'user-' + user.id" :class="'status_link ' + getFontColor(user.status)" @click="openStatusModal(user)"> {{ formatStatus(user.status) }}</a>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div class="row_item_readonly justify-content-md-center">
            <div class="text-red text-center m-4">{{ getNoRecordText(count, card_title) }}</div>
        </div>

        <ResetLinkModal 
            :isModalVisible="isResetLinkModal" 
            ref="reset_modal_popup"
            @close="closeResetLinkModal"
        />
        <UserActivateModal 
            :isModalVisible="isUserActivateModal" 
            ref="user_activate_modal"
            page_from="user_list"
            @close="closeUserActivateModal"
        />
        <UserInactivateModal
            :isModalVisible="isUserInactivateModal" 
            ref="user_inactivate_modal"
            page_from="user_list"
            @close="closeUserInactivateModal"
        />
        <AddTransferLinkModal 
            :isModalVisible="isTransferLinkModal" 
            :accountId="accountId"
            ref="add_transfer_modal_popup"
            @close="closeTransferLinkModal"
        />
    </div>
</template>
<script>
import ResetLinkModal from './loation_reset_modal.vue';
import UserActivateModal from './user_activate_modal.vue';
import UserInactivateModal from './user_inactivate_modal.vue';
import AddTransferLinkModal from './add_transfer_modal.vue';

export default {
    props: [
        'readOnly',
        'card_title', 
        'count', 
        'show_more', 
        'itemLength',
        'lessResult', 
        'allItems', 
        'btnName',
        'btnLink',
        'btnType',
        'isListType',
        'see_more_text',
        'isResponseStatus',
        'accountId',
        'loading',
        'isCanAddTransfer',
    ],
    data(){
        return {
            isResetLinkModal: false,
            isUserActivateModal: false,
            isUserInactivateModal: false,
            userId: '',
            resetLinkSuccessMsg: '',
            user_info: {},
            isTransferLinkModal: false,
        }
    },
    components: {
        ResetLinkModal,
        UserActivateModal,
        UserInactivateModal,
        AddTransferLinkModal,
    },
    methods: {
        clickShowMore() {
            this.$emit('click');
        },
        getFontColor(status) {
            if (status == 'ACTIVE' || status == 'Active')
                return 'text-red';
            else
                return 'text-green';
        },
        capitalizeFirstLetter(string) {
            if (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },
        formatStatus(status) {
            var status_text = 'Activate';
            if (status == 'ACTIVE' || status == 'Active') {
                status_text = 'Inactivate';
            }
            return status_text;
        },
        goToMenteeUserDetail(userId) {
            
        },
        goToUserDetail(userId) {
					if(this.card_title == 'Mentees') {
						this.$parent.menteeNavigate(userId);
					} else {
						this.$parent.navigate(userId);
					}
        },
        openResetLinkModal(user) {
            this.$parent.scrollTop();
            this.isResetLinkModal = true;
            user.accountId = this.accountId;
            this.$refs.reset_modal_popup.setUserInfo(user);
        },
        closeResetLinkModal() {
            this.isResetLinkModal = false;
            this.$refs.reset_modal_popup.setUserInfo({});
            setTimeout(() => {
                this.resetLinkSuccessMsg = '';
            }, 2000);
        },
        openStatusModal(user) {
            user.accountId = this.accountId;

            if (user.status == 'ACTIVE' || user.status == 'Active') {
                this.$parent.scrollTop();
                this.isUserInactivateModal = true;
                this.$refs.user_inactivate_modal.setUserInfo(user);
            } else {
                this.$parent.scrollTop();
                this.isUserActivateModal = true;
                this.$refs.user_activate_modal.setUserInfo(user);
            }
        },
        closeUserActivateModal() {
            this.isUserActivateModal = false;
        },
        closeUserInactivateModal() {
            this.isUserInactivateModal = false;
        },
        goToUsersTab() {
            this.$parent.statusUpdateSuccessMsg = 'User status updated Successfully';
            this.$parent.getListofAllUsers();
        },
        getNoRecordText(count, textMsg) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0 && this.isResponseStatus) {
                    return "No " + textMsg + " Found.";
                }
            }
        },
        openTransferLinkModal(user) {
            this.isTransferLinkModal = true;
            this.$refs.add_transfer_modal_popup.fetchLocationsListitems(user.id);
        },
        closeTransferLinkModal(msg) {
					if(msg) {
						this.$parent.getResponseFromAddTransfer(msg);
					}
					this.isTransferLinkModal = false;
        },
    }
}
</script>
<style scoped>
/* user tab css */
.users_heading_1 { width: 55%; cursor: pointer; }
.users_heading_2 { width: 15%; }
.users_heading_3 { width: 15%; } 
.users_heading_4 { width: 15%; font-weight: 900; }
.readonly_users_heading_1 { width: 100%; cursor: pointer; }
.user_offcanvas_header { float: left; font-weight: 900; cursor: pointer; margin-top: 15px; }
.user_offcanvas_content { float: left; font-weight: 500; }
.users_lists { padding: 10px 0 0 10px; }
.users_lists::after {
    content: "";
    display: block;
    width: 97%;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.users_lists:nth-last-child(1):after { border-bottom: 0 none; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.see-more { color: #00acee; font-weight: 900; }
.offcanvas_link { color: #00acee; text-decoration: underline !important; font-weight: 900; cursor: pointer; }
.status_link { text-decoration: underline !important; font-weight: 900; cursor: pointer; }
.uname { font-size: 14px;}
.uemail { font-size: 12px; font-style: italic; margin: 2px 0; }
/* user tab css */
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/location_users_list.vue